import "./NoticeItem.scoped.scss"

function NoticeItem() {
  return (
    <div className="notice-item">
      <div className="notice-item__title">회원 정지 사유</div>
      <div className="notice-item__contents">
        <p>- 한 화면에 두번 이상 같은 글 반복 작성</p>
        <p>- 상대 비방, 반말 또는 욕설</p>
        <p>- 비매너 채팅</p>
        <p>- 회원간 싸움 및 분란 조장</p>
        <p>- 결과 거짓 중계</p>
        <p>- 운영진의 판단하에 운영정책에 위배되는 행위</p>
      </div>
    </div>
  );
}

export default NoticeItem;